import gql from 'graphql-tag';

export const QUERY_PropertyName = gql`
  query CMS_Search($query: String, $pageNumber: Int, $pageSize: Int) {
    search(query: $query, pageNumber: $pageNumber, pageSize: $pageSize, publishedStatus: ALL) {
      totalCount
      edges {
        node {
          ... on Property {
            id
            name
            slug
          }
        }
      }
    }
  }
`;
